<div class="www-tra-list" id="trainingsList">
  <div class="www-tra-list__con">
    @if (isTrainingCategoriesFilterVisible()) {
      <app-trainings-categories
        [brand]="this.trainingBrand()"
        [categories]="categories()"
        [subCategories]="subCategories()"
        [categoryId]="categoryIdChange()"
        (filtersChanged)="onCategoryFilterValueChange($event)"
      />
    }
    <div class="www-tra-list__con__sea">
      <div class="www-form">
        <div class="group">
          <img
            class="www-tra-list__con__sea__zoom"
            ngSrc="assets/images/components/trainings-or-events/zoom.png"
            width="16"
            height="16"
          />
          <input
            class="www-tra-list__con__sea__inp"
            [(ngModel)]="search"
            id="search"
            type="text"
            autocomplete="off"
            placeholder="Wyszukaj"
          />
        </div>
      </div>
      <a (click)="filtersOpened.set(!filtersOpened())"
        ><span class="www-tra-list__con__sea__cat">{{ filtersOpened() ? 'ZAMKNIJ FILTRY' : 'OTWÓRZ FILTRY' }}</span></a
      >
    </div>

    <div class="www-tra-list__con__fl">
      <div
        class="www-tra-list__con__clo-arr d-md-none"
        [ngClass]="{ 'd-none': !filtersOpened() }"
        (click)="filtersOpened.set(false)"
        [appAnimate]="'fadeInLeft'"
        delay="2000"
      >
        <img src="assets/images/arrow-ios-forward-outline.svg" />
      </div>

      <div class="www-tra-list__con__fil" [ngClass]="{ 'www-tra-list__con__fil--open': filtersOpened() }">
        <app-trainings-filter
          (filtersChanged)="onFilterValueChange($event)"
          [categories]="categories()"
          [subCategories]="subCategories()"
          [places]="places()"
          [educators]="educators()"
          [isBrandFilterVisible]="isBrandFilterVisible()"
          [isCategoriesFilterVisible]="isCategoriesFilterVisible()"
          [brand]="trainingBrand()"
          [categoryId]="categoryIdChange()"
          [subCategoryId]="subCategoryIdChange()"
          [maxRangeValue]="maxRangeValue()"
          [sortTable]="sortTable"
          [cities]="cities()"
        />
      </div>

      @if (filtersOpened()) {
        <div (click)="filtersOpened.set(false)" class="www-tra-list__con__empty"></div>
      }
      <div
        class="www-tra-list__con__list"
        [appAnimate]="'fadeIn'"
        [speed]="'fast'"
        [ngClass]="{
          'www-tra-list__con__list--trans': filtersOpened(),
          'ver-scr-mob': !scrollXOnMobile(),
          'hor-scr-mob': scrollXOnMobile(),
        }"
      >
        @if (loading()) {
          <ngx-skeleton-loader
            class="www-tra-list__con__list__ske"
            [animation]="'progress'"
            [count]="3"
            appearance="circle"
          />
        } @else {
          @if (trainings()) {
            @for (tr of trainings()!.data; track $index) {
              <app-training-tile
                [training]="tr"
                [showPrice]="tr.slug !== 'madryt' && tr.slug !== 'singapur' && showPrices()"
                [trainingBrand]="trainingBrand()"
              />
            }

            @if (!trainings()!.data.length) {
              <div class="www-tra-list__con__list__empty mb-5">{{ emptyListText() }}</div>
            }
          }
        }
      </div>
    </div>
    @if (trainings()) {
      @if (totalPages() && totalPages() > 1 && showPagination()) {
        <div class="www-tra-list__con__list__pag">
          <app-paginator [totalPages]="totalPages()" (onPageChange)="pageChange($event)" />
        </div>
      }
    }
  </div>
</div>
